// Packages action types

const packagesActionTypes = {
  GET_PACKAGES_AVAILABILITY_INFO_SUCCESS: 'GET_PACKAGES_AVAILABILITY_INFO_SUCCESS',
  GET_PACKAGES_AVAILABILITY_INFO_LOADING: 'GET_PACKAGES_AVAILABILITY_INFO_LOADING',
  GET_PACKAGES_AVAILABILITY_INFO_ERROR: 'GET_PACKAGES_AVAILABILITY_INFO_ERROR',
  SET_SELECTED_PACKAGES: 'SET_SELECTED_PACKAGES',
  UPSERT_PACKAGES: 'UPSERT_PACKAGES',
  DELETE_PACKAGES: 'DELETE_PACKAGES',
  CLEAR_PACKAGES_PLAN: 'CLEAR_PACKAGES_PLAN',
  SET_PACKAGES_PLAN_INFO_SUCCESS: 'SET_PACKAGES_PLAN_INFO_SUCCESS',
  GTM_PACKAGES_IMPRESSIONS: 'GTM_PACKAGES_IMPRESSIONS'
};

export default packagesActionTypes;
